// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cv-a";
export var fulfillmentFormRail = "_cv-9";
export var headerTitleRow = "_cv-c";
export var orderDetailsWrapper = "_cv-7";
export var orderLinkTrigger = "_cv-2";
export var paymentInformationGrid = "_cv-h";
export var paymentSummaryColumn = "_cv-i";
export var shipmentContainer = "_cv-b";
export var shipmentDetailsMainPane = "_cv-8";
export var shipmentNavigationCard = "_cv-5";
export var shipmentNavigationRail = "_cv-3";
export var shipmentNavigationRailHeader = "_cv-4";
export var shipmentSummaryFact = "_cv-e";
export var shipmentSummaryGrid = "_cv-d";
export var shipmentSummaryMetadataRow = "_cv-f";
export var shipmentSummaryTags = "_cv-g";
export var shipmentWorkspace = "_cv-0";
export var shipmentWorkspaceContent = "_cv-6";
export var shipmentWorkspaceHeader = "_cv-1";